var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop } from 'vue-property-decorator';
import ReleaseCom from "../../components/releaseCom.vue";
import EOrderFromSystem from "../../enum/EOrderFromSystem";
import SelectStockBatch from './component/SelectStockBatch.vue';
var Auth = (function (_super) {
    __extends(Auth, _super);
    function Auth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderFromSystem = EOrderFromSystem;
        return _this;
    }
    Auth.prototype.selectStockBatch = function (row) {
        this.$refs.SelectStockBatch.show(row);
    };
    Auth.prototype.close = function () {
        this.$refs.release.hide();
    };
    Auth.prototype.showRelease = function () {
        this.$refs.release.show({ hasMask: true, className: "release-wrapper mul-shop-release-wrapper" });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], Auth.prototype, "shopList", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], Auth.prototype, "type", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); },
        })
    ], Auth.prototype, "detailData", void 0);
    Auth = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                canSelectBatch: 'canSelectBatch',
            })),
            components: {
                'release-com': ReleaseCom,
                'select-stock-batch': SelectStockBatch,
            }
        })
    ], Auth);
    return Auth;
}(Vue));
export default Auth;
